// =============================
// Увеличение количества товара в карточке. Кнопка +-1
// =============================
function initQuantityScript() {
  document.querySelectorAll(".custom-quantity").forEach((wrapper) => {
    const minusBtn = wrapper.querySelector(".qty-btn.minus");
    const plusBtn = wrapper.querySelector(".qty-btn.plus");
    const quantityInput = wrapper.querySelector(".qty-input");
    const priceElement = document.querySelector("[data-product-price]");
    const form = document.querySelector(
      `#${quantityInput.getAttribute("form")}`
    );

    if (!minusBtn || !plusBtn || !quantityInput || !form) return;

    let basePrice = 0;
    if (priceElement) {
      const priceText = priceElement.innerText
        .replace(/[^\d,]/g, "")
        .replace(",", ".");
      basePrice = parseFloat(priceText);
    }

    const updateValue = (delta) => {
      let current = parseInt(quantityInput.value) || 1;
      current += delta;
      if (current < 1) current = 1;
      quantityInput.value = current;

      const event = new Event("change", {
        bubbles: true,
        cancelable: true,
      });
      quantityInput.dispatchEvent(event);

      if (priceElement && basePrice > 0) {
        const total = (basePrice * current).toFixed(2).replace(".", ",");
        priceElement.innerText = `${total} zł`;
      }
    };

    minusBtn.addEventListener("click", (e) => {
      e.preventDefault();
      updateValue(-1);
    });

    plusBtn.addEventListener("click", (e) => {
      e.preventDefault();
      updateValue(1);
    });

    form.addEventListener("submit", function (e) {
      const formData = new FormData(form);
      formData.set("quantity", quantityInput.value);

      return true;
    });
  });
}

document.addEventListener("DOMContentLoaded", initQuantityScript);
document.addEventListener("shopify:section:load", initQuantityScript);
document.addEventListener("shopify:section:select", initQuantityScript);

// =============================
// Иконка копирования в карточке
// =============================
window.copyProductLink = function (button) {
  button.style.transform = "scale(0.9)";
  button.style.backgroundColor = "#f0f0f0";

  const svg = button.querySelector("svg");
  const originalSVG = svg.innerHTML;

  svg.innerHTML = `
    <path d="M5 13l4 4L19 7" stroke="currentColor" stroke-width="2" fill="none"
      stroke-linecap="round" stroke-linejoin="round"/>
  `;

  setTimeout(() => {
    svg.innerHTML = originalSVG;
    button.style.transform = "scale(1)";
    button.style.backgroundColor = "transparent";
  }, 2000);

  navigator.clipboard.writeText(window.location.href).catch((err) => {
    console.error("Ошибка копирования:", err);
  });
};

document.addEventListener("DOMContentLoaded", function () {
  const thumbs = document.querySelector(".product__thumbs");
  const info = document.querySelector(".product__info-wrapper"); // правая часть страницы

  if (!thumbs || !info) return;

  thumbs.addEventListener("mouseenter", () => {
    document.body.style.overflow = "hidden";
  });

  thumbs.addEventListener("mouseleave", () => {
    document.body.style.overflow = "auto";
  });

  info.addEventListener("mouseenter", () => {
    document.body.style.overflow = "auto";
  });
});
const gallery = document.querySelector(".product__photos");

if (gallery) {
  gallery.addEventListener("mouseenter", () => {
    document.body.classList.add("no-scroll");
  });

  gallery.addEventListener("mouseleave", () => {
    document.body.style.overflow = "auto";
  });
}

// =============================
// Исправление галереи на десктопе
// =============================
document.addEventListener("DOMContentLoaded", function () {
  const thumbnails = document.querySelectorAll(".product__thumb-item a");
  const mainImage = document.querySelector(".product__main-photos-wrapper img");

  thumbnails.forEach(function (thumbnail) {
    thumbnail.addEventListener("click", function (e) {
      const largeImage = e.target.closest("a").href;
      mainImage.src = largeImage;
    });
  });
});

// =============================
// Открытие ссылки не по иконке
// =============================
document.addEventListener("DOMContentLoaded", function () {
  document
    .querySelectorAll("summary.site-nav__link--has-dropdown")
    .forEach(function (summary) {
      summary.addEventListener("click", function (e) {
        if (!e.target.closest("svg")) {
          const link = summary.getAttribute("data-link");
          if (link) {
            window.location.href = link;
          }
        }
      });
    });
});

// =============================
// Фиксированию меню третьего уровня
// =============================
document.addEventListener("DOMContentLoaded", function () {
  document
    .querySelectorAll('.slide-nav__dropdown[data-level="3"]')
    .forEach((menu) => {
      const returnBtn = menu.querySelector("button.js-toggle-submenu");

      if (returnBtn && !returnBtn.classList.contains("slide-nav__return-btn")) {
        returnBtn.classList.add("slide-nav__return-btn");

        if (!returnBtn.dataset.level) {
          returnBtn.setAttribute("data-level", "3");
        }

        if (!returnBtn.dataset.target) {
          const parentId = menu.getAttribute("data-parent");
          if (parentId) {
            returnBtn.setAttribute("data-target", parentId);
          }
        }
      }
    });
});

// =============================
// ФИЛЬТРАЦИЯ
// =============================

// =============================
// Убрать фильтр для страниц
// =============================
// if (
//   window.location.pathname === "/collections/akcesoria" ||
//   window.location.pathname === "/collections/sprzet-sportowy"
// ) {
//   const sizeFilter = document.querySelector(".collection-filter__group--2");
//   if (sizeFilter) {
//     sizeFilter.style.display = "none";
//   }
// }

// =============================
// Порядок фильтров от xs до l
// =============================
document.addEventListener("DOMContentLoaded", function () {
  setTimeout(function () {
    function sortFilters(filterGroup, sizeOrder) {
      var filterList = filterGroup.querySelector(".tag-list");

      if (!filterList) return;

      var sizeFilters = Array.from(filterList.querySelectorAll("li.tag"));

      sizeFilters.sort(function (a, b) {
        var sizeA = a.querySelector(".tag__text").textContent.trim();
        var sizeB = b.querySelector(".tag__text").textContent.trim();

        return sizeOrder.indexOf(sizeA) - sizeOrder.indexOf(sizeB);
      });

      sizeFilters.forEach(function (filter) {
        filterList.appendChild(filter);
      });
    }

    var filterGroups = document.querySelectorAll(".collection-filter__group");

    filterGroups.forEach(function (group) {
      if (group.classList.contains("collection-filter__group--2")) {
        var sizeOrder1 = [
          "XS (50-60 cm)",
          "S (65-70 cm)",
          "M (75-80 cm)",
          "L (85-90 cm)",
        ];
        sortFilters(group, sizeOrder1);
      } else if (group.classList.contains("collection-filter__group--2")) {
        var sizeOrder2 = [
          "XS (25x26cm)",
          "S (28x27 cm)",
          "M (31x29 cm)",
          "L (33x30 cm)",
          "XL (35x31 cm)",
        ];
        sortFilters(group, sizeOrder2);
      }
    });
  }, 100);
});

// Получение уникальных значений размеров
function getUniqueSizes(sizes) {
  const uniqueSizes = [];
  sizes.forEach((size) => {
    if (!uniqueSizes.includes(size)) {
      uniqueSizes.push(size);
    }
  });
  return uniqueSizes;
}

// =============================
// Кнопка Очистить все в фильтрах
// =============================
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".clear-all-filters-btn").forEach((btn) => {
    btn.addEventListener("click", (event) => {
      event.preventDefault();
      const url = new URL(window.location.href);
      url.search = "";
      history.pushState(null, "", url.pathname);
      theme.CollectionAjaxFilter(new URLSearchParams(), false);
    });
  });
});

// =============================
// Отображение списка коллекции в 1 или 2 колонки
// =============================
document.addEventListener("DOMContentLoaded", function () {
  let isMovedToMobile = false;

  const icons = {
    "view1-active": `<svg width="35" height="45" viewBox="0 0 35 45" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="35" height="45" rx="5" fill="#D9D9D9"/></svg>`,
    "view1-inactive": `<svg width="35" height="45" viewBox="0 0 35 45" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="1.25" y="1.25" width="32.5" height="42.5" rx="3.75" stroke="black" stroke-width="2.5"/></svg>`,
    "view2-active": `<svg width="35" height="45" viewBox="0 0 35 45" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0)"><rect width="16" height="21" fill="#D9D9D9"/><rect x="19" width="16" height="21" fill="#D9D9D9"/><rect y="24" width="16" height="21" fill="#D9D9D9"/><rect x="19" y="24" width="16" height="21" fill="#D9D9D9"/></g><defs><clipPath id="clip0"><rect width="35" height="45" rx="5" fill="white"/></clipPath></defs></svg>`,
    "view2-inactive": `<svg width="35" height="45" viewBox="0 0 35 45" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0)"><path d="M5 1.25H14.75V19.75H1.25V5C1.25 2.92893 2.92893 1.25 5 1.25Z" stroke="black" stroke-width="2.5"/><path d="M30 1.25C32.0711 1.25 33.75 2.92893 33.75 5V19.75H20.25V1.25H30Z" stroke="black" stroke-width="2.5"/><path d="M14.75 25.25V43.75H5C2.92893 43.75 1.25 42.0711 1.25 40V25.25H14.75Z" stroke="black" stroke-width="2.5"/><path d="M33.75 25.25V40C33.75 42.0711 32.0711 43.75 30 43.75H20.25V25.25H33.75Z" stroke="black" stroke-width="2.5"/></g><defs><clipPath id="clip0"><rect width="35" height="45" rx="5" fill="white"/></clipPath></defs></svg>`,
  };

  function isMobile() {
    return window.innerWidth <= 768;
  }

  function setMobileView(columns) {
    const productGrid = document.querySelector("[data-collection-container]");
    const view1 = document.getElementById("view1");
    const view2 = document.getElementById("view2");

    if (!isMobile() || !productGrid) return;

    productGrid.classList.remove(
      "grid--scattered-small-1",
      "grid--scattered-small-2"
    );
    productGrid.classList.add(`grid--scattered-small-${columns}`);
    localStorage.setItem("mobileView", columns);

    if (view1 && view2) {
      view1.classList.toggle("active", columns === 1);
      view2.classList.toggle("active", columns === 2);
      view1.innerHTML =
        columns === 1 ? icons["view1-active"] : icons["view1-inactive"];
      view2.innerHTML =
        columns === 2 ? icons["view2-active"] : icons["view2-inactive"];
    }
  }

  function setupViewToggleButtons() {
    const view1 = document.getElementById("view1");
    const view2 = document.getElementById("view2");

    if (view1) view1.addEventListener("click", () => setMobileView(1));
    if (view2) view2.addEventListener("click", () => setMobileView(2));

    const saved = localStorage.getItem("mobileView");
    if (isMobile() && (saved === "1" || saved === "2")) {
      setMobileView(parseInt(saved));
    } else if (isMobile()) {
      setMobileView(2);
    }
  }

  function setupMobileFilters() {
    const openBtn = document.querySelector(".open-mobile-filters-btn");
    const closeBtn = document.querySelector(".close-mobile-filters-btn");
    const modal = document.getElementById("MobileFiltersModal");
    const filterBlock = document.getElementById("CollectionFiltersSection");
    const desktopWrapper = document.querySelector(
      ".collection-sidebar .collection-filters"
    );
    const mobileTarget = document.getElementById(
      "CollectionFiltersSectionMobile"
    );

    let isMovedToMobile = false;

    function openModal() {
      if (!isMovedToMobile && filterBlock && mobileTarget) {
        mobileTarget.appendChild(filterBlock);
        isMovedToMobile = true;
      }
      modal.classList.add("show");
      document.body.classList.add("modal-open");
    }

    function closeModal() {
      if (isMovedToMobile && filterBlock && desktopWrapper) {
        desktopWrapper.insertBefore(filterBlock, desktopWrapper.firstChild);
        isMovedToMobile = false;
      }
      modal.classList.remove("show");
      document.body.classList.remove("modal-open");
    }

    if (openBtn) openBtn.addEventListener("click", openModal);
    if (closeBtn) closeBtn.addEventListener("click", closeModal);
    if (modal) {
      modal.addEventListener("click", (e) => {
        if (e.target === modal) closeModal();
      });
    }
  }

  setupViewToggleButtons();
  setupMobileFilters();

  document.addEventListener("shopify:section:load", () => {
    setupViewToggleButtons();
    setupMobileFilters();
  });

  document.addEventListener("shopify:section:reorder", () => {
    setupViewToggleButtons();
    setupMobileFilters();
  });

  const observer = new MutationObserver(() => {
    setupViewToggleButtons();
  });
  const ajaxTarget = document.getElementById("CollectionAjaxContent");
  if (ajaxTarget) {
    observer.observe(ajaxTarget, { childList: true, subtree: true });
  }
});

// =============================
// Фильтры-аккордеоны
// =============================
function handleAccordionClick(event) {
  const button = event.currentTarget;
  const panelId = button.getAttribute("aria-controls");
  const isExpanded = button.getAttribute("aria-expanded") === "true";
  const panel = document.getElementById(panelId);

  document.querySelectorAll(".filter-accordion__toggle").forEach((otherBtn) => {
    const otherPanelId = otherBtn.getAttribute("aria-controls");
    const otherPanel = document.getElementById(otherPanelId);
    if (otherBtn !== button) {
      otherBtn.setAttribute("aria-expanded", "false");
      if (otherPanel) {
        otherPanel.style.maxHeight = "0";
      }
    }
  });

  if (!isExpanded) {
    button.setAttribute("aria-expanded", "true");
    panel.style.maxHeight = panel.scrollHeight + "px";
    sessionStorage.setItem("openAccordion", panelId); // сохранить
  } else {
    button.setAttribute("aria-expanded", "false");
    panel.style.maxHeight = "0";
    sessionStorage.removeItem("openAccordion");
  }
}

function initAccordionFilters() {
  const openId = sessionStorage.getItem("openAccordion") || null;

  document.querySelectorAll(".filter-accordion__toggle").forEach((button) => {
    const panelId = button.getAttribute("aria-controls");
    const panel = document.getElementById(panelId);
    if (!panel) return;

    panel.hidden = false;
    panel.style.overflow = "hidden";
    panel.style.maxHeight = "0";

    const isRestoring = openId === panelId;

    if (isRestoring) {
      panel.style.transition = "none";
      panel.style.maxHeight = panel.scrollHeight + "px";
      button.setAttribute("aria-expanded", "true");

      requestAnimationFrame(() => {
        panel.style.transition = "max-height 0.3s ease";
      });
    } else {
      panel.style.transition = "max-height 0.3s ease";
      button.setAttribute("aria-expanded", "false");
    }

    if (button.dataset.listenerAttached) return;
    button.dataset.listenerAttached = "true";
    button.addEventListener("click", handleAccordionClick);
  });
}

function observeDOMChanges() {
  const observer = new MutationObserver(() => {
    initAccordionFilters();
  });
  observer.observe(document.body, { childList: true, subtree: true });
}

document.addEventListener("DOMContentLoaded", () => {
  initAccordionFilters();
  observeDOMChanges();
});

// =============================
// Добавление счетчика при активном фильтре
// =============================
function updateMobileFilterButton() {
  const button = document.querySelector(".open-mobile-filters-btn");
  const badge = document.querySelector(".filters-count-badge");

  if (!button || !badge) return;

  const checkedFilters = document.querySelectorAll(
    '#CollectionFiltersSection input[type="checkbox"]:checked, #CollectionFiltersSectionMobile input[type="checkbox"]:checked'
  );

  // Убираем дубли (на мобилке и десктопе одинаковые значения)
  const uniqueFilterNames = new Set();

  checkedFilters.forEach((checkbox) => {
    const key = checkbox.name + ":" + checkbox.value;
    uniqueFilterNames.add(key);
  });

  const count = uniqueFilterNames.size;

  if (count > 0) {
    button.classList.add("active");
    badge.classList.remove("hidden");
    badge.textContent = count;
  } else {
    button.classList.remove("active");
    badge.classList.add("hidden");
    badge.textContent = "";
  }
}

function observeFilterChanges() {
  const selectors = [
    "#CollectionFiltersSection",
    "#CollectionFiltersSectionMobile",
  ];

  selectors.forEach((selector) => {
    const target = document.querySelector(selector);
    if (!target) return;

    const observer = new MutationObserver(() => {
      updateMobileFilterButton();
    });

    observer.observe(target, {
      childList: true,
      subtree: true,
    });
  });
}

document.addEventListener("DOMContentLoaded", () => {
  updateMobileFilterButton();
  observeFilterChanges();
});

document.addEventListener("page:loaded", () => {
  updateMobileFilterButton();
  observeFilterChanges();
});

// =================
// Улучшение поиска
// =================
document.addEventListener("DOMContentLoaded", function () {
  const searchForms = document.querySelectorAll('form[action="/search"]');

  searchForms.forEach((form) => {
    form.addEventListener("submit", function (e) {
      const input = this.querySelector('input[name="q"]');
      let query = input.value.trim();

      query = query.toLowerCase().replace(/[-\s]/g, "");

      e.preventDefault();
      window.location.href = `/search?type=product&q=${encodeURIComponent(
        query
      )}*`;
    });
  });
});

//=============================================
// Выбор варианта из галереи (карточка товара)
//=============================================
// document.addEventListener('DOMContentLoaded', () => {
//   const slideshow = document.querySelector('.product-slideshow.flickity-enabled');
//   if (!slideshow) return;

//   const flkty = Flickity.data(slideshow);
//   if (!flkty) return;

//   flkty.on('change', (index) => {
//     const slide = flkty.slides[index];
//     if (!slide || !slide.cells[0]) return;

//     const slideEl = slide.cells[0].element;
//     const img = slideEl.querySelector('img');
//     if (!img) return;

//     const alt = img.getAttribute('alt') || '';
//     const src = img.getAttribute('src') || '';

//     // Все варианты цвета
//     const variantInputs = document.querySelectorAll(
//       'input[type="radio"][name="Color"]'
//     );

//     let matchedInput = null;

//     variantInputs.forEach(input => {
//       const value = input.value.toLowerCase();

//       if (
//         alt.toLowerCase().includes(value) ||
//         src.toLowerCase().includes(value.replace(/\s+/g, '_'))
//       ) {
//         matchedInput = input;
//       }
//     });

//     if (!matchedInput.checked) {
//       matchedInput.checked = true;
//       matchedInput.dispatchEvent(new Event('change', { bubbles: true }));
//     }
//   });
// });


// // Выбранный вариант товара первым в списке вариантов
// document.addEventListener('DOMContentLoaded', () => {
//   function moveSelectedVariantFirst() {
//     const variantWrapper = document.querySelector('.variant-input-wrap');
//     if (!variantWrapper) return;
//     const checkedInput = variantWrapper.querySelector('input[type="radio"]:checked');
//     if (!checkedInput) return;
//     const variantItem = checkedInput.closest('.variant-input, label');
//     if (!variantItem) return;
//     if (variantWrapper.firstElementChild === variantItem) return;
//     variantWrapper.insertBefore(variantItem, variantWrapper.firstElementChild);
//   }

//   document.addEventListener('change', (e) => {
//     if (e.target.matches('.variant-input-wrap input[type="radio"]')) {
//       moveSelectedVariantFirst();
//     }
//   });

//   document.addEventListener('variant:change', () => {
//     moveSelectedVariantFirst();
//   });
// });
